import { useCallback } from 'react';
import SweetAlert from '@components/Feedback/SweetAlert/Index.jsx';
import { AnswerSolicitacao, SendActionPlanSolicitacao } from '@services/Solicitacao/Index.jsx';
import ValidationsAnswerSolicitacao from '@validations/Solicitacao/User/Validations.jsx';
import { useDispatch } from 'react-redux';
import { atualizarStatus } from '@store/slices/solicitacaoSlice.js';
import { addHistorico } from '@store/slices/solicitacaoHistoricoSlice.js';

export const useSolicitacaoRespostaHandlers = ({ solicitacaoFields, solicitacaoProcessoItems }) => {
  const dispatch = useDispatch();
  const NumeroSolicitacao = solicitacaoFields?.numeroSolicitacao;

  // Função para enviar a resposta da solicitação
  const onSubmitRequest = useCallback(async () => {
    const title = "Envio da Resposta da Solicitação";
    const htmlMessage = `Deseja realmente enviar a resposta para a solicitação de número <strong>${NumeroSolicitacao}</strong>?`;

    const confirmEnvioSolicitacao = await SweetAlert.warningHTML(title, htmlMessage);
    if (!confirmEnvioSolicitacao) return;

    SweetAlert.loading();

    const { validateFormularioRespostaItemProcesso, validateFormularioRespostaProcesso } = ValidationsAnswerSolicitacao();
    const itemError = await validateFormularioRespostaItemProcesso(solicitacaoFields?.id, solicitacaoProcessoItems);
    if (itemError) {
      SweetAlert.errorHTML("Formulários Pendentes", itemError.html);
      return;
    }

    const procError = await validateFormularioRespostaProcesso(solicitacaoFields?.id, solicitacaoFields?.formularioAssociadoProcesso);
    if (procError) {
      SweetAlert.errorHTML("Formulário Processo Pendente", procError.html);
      return;
    }

    try {
      const result = await AnswerSolicitacao(solicitacaoFields?.id);

      if (!result || !result.numeroSolicitacao) {
        SweetAlert.error('Erro ao Enviar Resposta', 'Não foi possível enviar a resposta da solicitação.');
        return;
      }

      dispatch(atualizarStatus({ id: solicitacaoFields.id, status: result.numeroStatusSolicitacao }));
      dispatch(addHistorico(result.solicitacaoHistorico));

      SweetAlert.success(
        'Resposta Enviada!',
        'O e‑mail de notificação foi encaminhado ao Auditor associado a esta solicitação.'
      );
    } catch (error) {

      // let errorMessage = 'Ocorreu um problema ao tentar salvar os dados.';

      // const message = error.response?.data?.message

      // if (message === 'REMETENTE_INVALIDO') {
      //   SweetAlert.error('Remetente inválido', 'A conta de e-mail do remetente está inativa ou não possui uma caixa de entrada válida.');
      //   return;
      // }

      // SweetAlert.errorHTML('Erro ao enviar a resposta da Solicitação', errorMessage);
      // console.error(error);

      const errorMessage = error.parsed?.message || 'Não foi possível enviar a resposta da solicitação.';

      SweetAlert.errorHTML('Erro ao enviar', errorMessage);
      console.error(error);
    }
  }, [solicitacaoFields, solicitacaoProcessoItems, dispatch]);



  // Função para enviar o plano de ação
  const onSubmitActionPlan = useCallback(async () => {
    const title = "Envio do Plano de Ação da Solicitação";
    const htmlMessage = `Deseja realmente enviar o plano de ação da solicitação de número <strong>${NumeroSolicitacao}</strong>?`;

    const confirmEnvioSolicitacao = await SweetAlert.warningHTML(title, htmlMessage);
    if (!confirmEnvioSolicitacao) return;

    SweetAlert.loading();

    const { validatePlanoAcao } = ValidationsAnswerSolicitacao();
    const error = await validatePlanoAcao(
      solicitacaoFields?.compliance?.idProcesso,
      solicitacaoFields?.unidadeGerencia?.id
    );

    if (error) {
      SweetAlert.errorHTML("Erro ao Enviar Plano de Ação", error.html);
      return;
    }

    try {
      const result = await SendActionPlanSolicitacao(solicitacaoFields?.id);

      if (!result || typeof result.statusSolicitacao === 'undefined') {
        SweetAlert.error('Erro ao Enviar Plano de Ação', 'Não foi possível enviar o plano de ação da solicitação.');
        return;
      }

      dispatch(atualizarStatus({ id: solicitacaoFields.id, status: result.numeroStatusSolicitacao }));
      dispatch(addHistorico(result.solicitacaoHistorico));

      SweetAlert.success(
        'Plano de Ação Enviado!',
        'O e‑mail de notificação foi encaminhado ao Auditor associado a esta solicitação.'
      );

    } catch (err) {
      const errorMessage = error.parsed?.message || 'Não foi possível enviar o plano de ação da solicitação.';

      SweetAlert.errorHTML('Erro ao enviar', errorMessage);
      console.error(error);
    }
  }, [solicitacaoFields, dispatch]);

  return {
    onSubmitRequest,
    onSubmitActionPlan
  };
};
